import { TypedOutputLoggerInstanceType } from './types';

export let newInternalLogger: TypedOutputLoggerInstanceType;

export const updateBareboneLogger = (
  newLogger: TypedOutputLoggerInstanceType
): void => {
  newInternalLogger = newLogger;
};
